<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{ '音声ファイルダウンロード' | translate }}</h1>
</div>

<div class="filter-field">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">
    {{dataSource}}

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="74" style="text-align:center"> No. </th>
      <td mat-cell *matCellDef="let exhibitAttribute; let i = index" style="text-align:right"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }} </td>
    </ng-container>

    <ng-container matColumnDef="category">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="150"> {{ 'カテゴリ' | translate }} </th>
      <td mat-cell *matCellDef="let files" [style.width.px]="150"> &nbsp;{{ files.category }} </td>
    </ng-container>

    <ng-container matColumnDef="serial_id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let files"></td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="150"> ID </th>
      <td mat-cell *matCellDef="let files" [style.width.px]="150"> {{ files.id }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ '名称' | translate }} </th>
      <td mat-cell *matCellDef="let files">
        {{ files.name | multiName:projectLanguages:projectBaseLang }}
      </td>
    </ng-container>

    <ng-container matColumnDef="language">
      <th mat-header-cell mat-sort-header *matHeaderCellDef [style.width.px]="200"> {{ '言語' | translate }} </th>
      <td mat-cell *matCellDef="let files"> {{ files.language }} </td>
    </ng-container>

    <ng-container matColumnDef="download">
      <th mat-header-cell  *matHeaderCellDef [style.width.px]="154" style="text-align:center"> {{ 'ダウンロード' | translate }} </th>
      <td mat-cell *matCellDef="let files" [style.width.px]="130" style="text-align:center">
        <button mat-raised-button color="primary" (click)="download(files)">{{ 'ダウンロード' | translate }}</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>
